import { MessageCircle, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";

const IMG = "https://customer-assets-v7afamib.emergentagent.net/job_educaser-dev/artifacts/wf996gnc_pexels-keira-burton-6147219.webp";

export default function VideoTestimonial() {
  return (
    <section className="bg-white pb-24 lg:pb-32" data-testid="video-testimonial">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <div className="grid grid-cols-1 overflow-hidden rounded-3xl lg:grid-cols-2">
          {/* Media */}
          <div className="relative min-h-[360px] lg:min-h-[520px]">
            <img src={IMG} alt="Témoignage d'un stagiaire Educaser" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
            <span className="absolute bottom-6 left-6 rounded-lg bg-brand-blue px-4 py-2 font-display text-sm font-bold text-white">
              « Nous avons été accompagnés de A à Z »
            </span>
          </div>

          {/* Panel */}
          <div className="relative flex flex-col justify-center bg-brand-blue p-10 lg:p-16">
            <MessageCircle className="absolute right-8 top-8 h-10 w-10 text-brand-red-light" />
            <Reveal>
              <h2 className="max-w-md font-display text-4xl font-black uppercase leading-[0.98] tracking-[-0.03em] text-white sm:text-5xl">
                Ils en parlent mieux que nous
              </h2>
              <p className="mt-6 max-w-md leading-relaxed text-white/80">
                Se former aux métiers du transport, c'est ouvrir la porte d'un secteur qui recrute.
                Mais comment choisir la bonne formation et réussir son financement ?
              </p>
              <p className="mt-4 max-w-md leading-relaxed text-white/80">
                Nos stagiaires — conducteurs de marchandises, de voyageurs, futurs enseignants —
                partagent leurs expériences, leurs conseils et les clés de leur réussite.
              </p>
              <button
                onClick={() => document.getElementById("temoignages")?.scrollIntoView({ behavior: "smooth", block: "start" })}
                className="group mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-brand-red px-7 py-3.5 font-bold text-white transition-colors hover:bg-brand-red-light"
                data-testid="video-testimonial-cta"
              >
                Découvrir les témoignages
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
